<template>
  <div>
    <div class="result_block">
      <div class="header-part">New Message</div>
      <div class="body-part">
        <div class="subscr-example_block">
          <div class="feature">To:</div>
          <div class="feature">Subject:</div>
          <hr>
          <div class="message">Hi! I wanted to let you know I just published a new post on my blog that I am sure you’ll find useful.</div>
        </div>

        <div id="subscrExampleBlock" class="preview-plug_block" v-if="!isEmpty">
          👀
          <div class="text">There will be online preview of your signature</div>
        </div>

        <div ref="finalSubscr"
             id="finalSubscr"
             class="final-subscr_block"
             v-else>

            <div style="width: 100%;">
                <div style="width: 100%;">
                    <div v-if="inputValues.name" style="width: 100%;">
                        <div style="padding-bottom: 12px; font-size: 18px; line-height: 1.4; font-weight: bold; color: #242930;">{{ inputValues.name }}</div>
                    </div>
                    <div v-if="selectedCompany.value || inputValues.position">
                        <div style="padding: 0 0 2px 0;">
                            <div style="display: flex;">
                                <div v-if="selectedCompany.logoUrl && isLinkableCompany" style="vertical-align: middle; font-size: 0;">
                                    <a :href="selectedCompany.link" target="_blank" rel="noopener noreferrer">
                                        <img :src="selectedCompany.logoUrl" width="24" height="24" style="margin-right: 12px;">
                                    </a>
                                </div>
                                <div v-else-if="selectedCompany.logoUrl" style="vertical-align: middle; font-size: 0;">
                                    <img :src="selectedCompany.logoUrl" width="24" height="24" style="margin-right: 12px;">
                                </div>
                                <div v-if="selectedCompany.value || inputValues.position" style="font-size: 16px; line-height: 1.5; color: #242930;">
                                    <span style="word-break: break-word;">{{ inputValues.position }}, </span>
                                    <span>{{ selectedCompany.value }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="inputValues.email || inputValues.phone" style="width: 100%;">
                        <div style="width: 100%; font-size: 16px; line-height: 1.5; color: #606670;">
                            <div style="display: flex; align-items: center; max-width: 100%; width: 100%;">
                                <span style="display: inline-flex; max-width: calc(100% - 130px);">
                                    <span v-if="inputValues.email"
                                          style="display: inline-block; max-width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding-right: 5px;">
                                        {{ inputValues.email }}
                                    </span>
                                </span>
                                <span style="display: inline-flex; flex: auto;">
                                    <span v-if="inputValues.phone"
                                          style="display: inline-flex; align-items: center; flex: auto;">
                                        | {{ inputValues.phone }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      </div>
    </div>

    <button @click="handleCopyButtonClick"
            class="button default-size full-width blue uppercase"
            type="button">
      Copy your signature
    </button>
  </div>
</template>

<script>
export default {
  name: "ResultBlock",
  props: {
    inputValues: {
      type: Object,
      required: true,
    },
    selectedCompany: {
      type: Object,
      required: true
    }
  },
  methods: {
    updateSelectResult: function() {
      this.$emit('selected-company', this.selectedCompany)
    },
    /* Проверка на валидность */
    handleCopyButtonClick() {
      // Проверяем наличие класса у всех полей
      const inputsValid = Array.from(document.querySelectorAll('.required-element')).every(input => input.classList.contains('success-input'));

      if (inputsValid) {
        // Если все поля валидны, копируем содержимое
        this.copyToClipboard();
      } else {
        // Если есть невалидные поля, подсвечиваем их красным на несколько секунд
        const invalidInputs = document.querySelectorAll('.required-element:not(.success-input)');
        invalidInputs.forEach(input => {
          input.closest('.form-group').classList.add('input-error');
        });
        setTimeout(() => {
          invalidInputs.forEach(input => {
            input.closest('.form-group').classList.remove('input-error');
          });
        }, 500);
      }
    },
    /* Метод для копирования кода подписи и вівода уведомления об успешности копирования */
    copyToClipboard() {
      const doc = document;
      const text = this.$refs.finalSubscr;
      let range, selection;

      if (doc.body.createTextRange) {
        range = doc.body.createTextRange();
        range.moveToElementText(text);
        range.select();
        doc.execCommand("copy"); // копирование текста
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = doc.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
        doc.execCommand("copy"); // копирование текста
        document.getSelection().removeAllRanges();
      }

      // вывод сообщения об успешном копировании
      const copyMessage = document.createElement("div");
      copyMessage.classList.add("copy-message");
      copyMessage.textContent = "Your signature has been copied to the clipboard.";
      document.body.appendChild(copyMessage);
      setTimeout(() => {
        copyMessage.classList.add("fade-out");
        setTimeout(() => {
          copyMessage.remove();
        }, 500);
      }, 3000);
    },
    resetInputValues() {
      this.$emit("resetInputValues");
    },
    toggleExampleBlock(isAuthenticated) {
      if (!isAuthenticated) {
        this.resetInputValues();
      }
    },
  },
  mounted() {
    this.updateSelectResult();
    this.$root.$on("authenticationChanged", this.toggleExampleBlock);
  },
  computed: {
    isEmpty() {
      const values = [...Object.values(this.inputValues), ...Object.values(this.selectedCompany)];

      // Проверяем каждое значение, используя метод `some()`
      return values.some(function(value) {
        // Удаляем начальные и конечные пробелы с помощью метода `trim()`
        const trimmedValue = value.trim();

        // Если значение не равно пустой строке после удаления пробелов, возвращаем `true`
        return trimmedValue !== '';
      });
    },
    isLinkableCompany() {
      const linkableCompanies = ['PDFLiner', 'Asolytics'];
      return linkableCompanies.includes(this.selectedCompany.value);
    },
  },
}
</script>

<style lang="scss">
  .result_block {
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
    border-radius: 4px;
    box-shadow: 0 4px 12px 0 rgba(95, 136, 204, 0.16);
    background-color: #fff;
    .header-part {
      display: flex;
      align-items: center;
      height: 50px;
      padding: 0 20px;
      border-radius: 4px 4px 0 0;
      background: #e7edf8;
      line-height: 1.33;
      font-size: 18px;
      font-weight: bold;
      cursor: default;
      color: #242930;
    }
    .body-part {
      padding: 20px 20px 24px 20px;
      border-radius: 0 0 4px 4px;
    }

    @media only screen and (max-width: 640px) {
      .header-part {
        padding: 0 16px;
      }
      .body-part {
        padding: 16px;
      }
    }
  }

  .subscr-example_block {
    display: flex;
    flex-direction: column;
    .feature {
      margin-bottom: 12px;
      line-height: 1.5;
      cursor: default;
      color: #b5b8be;
    }
    hr {
      margin: 8px 0 20px 0;
      border: 1px solid #e2e6ed;
      box-shadow: none;
    }
    .message {
      line-height: 1.5;
      color: #606670;
      cursor: default;
    }
  }

  .preview-plug_block {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;
    padding: 38px 30px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D3D8E2FF' stroke-width='4' stroke-dasharray='10%2c 9' stroke-dashoffset='2' stroke-linecap='square'/%3e%3c/svg%3e");
    font-family: 'PT Sans', sans-serif;
    line-height: 1.5;
    text-align: center;
    cursor: pointer;
    color: #3c3c3c;
  @media only screen and (max-width: 640px) {
    padding: 24px 16px;
  }

}

  .final-subscr_block {
    display: flex;
    margin-top: 32px;
    @media only screen and (max-width: 640px) {
      margin-top: 30px;
    }
  }

  .copy-message {
    position: fixed;
    bottom: 20px;
    left: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transform: translateX(-50%);
    padding: 10px 20px 12px 20px;
    background-color: #4CAF50;
    line-height: 1;
    color: white;
    border-radius: 5px;
    opacity: 1;
    transition: opacity 1s ease-in-out;
    z-index: 1000;
  }

  .fade-out {
    opacity: 0;
  }
</style>